<template>
  <div>
    <h2>Dashboard Comptable</h2>
  </div>
</template>

<script setup>
// DashboardComptable logic here
</script> 